import { Component, Output, ViewChildren, ViewChild, EventEmitter, QueryList, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators }  from '@angular/forms';
import { SignatureFieldComponent } from './../signature-field/signature-field.component';

@Component({
  selector: 'signature-group',
  templateUrl: 'signature-group.component.html',
  styleUrls: ['./signature-group.component.scss'],
})
export class SignatureGroupComponent {
  form: FormGroup;
  @Output() onDone = new EventEmitter<any>();
  @ViewChild(SignatureFieldComponent, {static: false}) public sig: SignatureFieldComponent;
  @ViewChildren('sigContainer1') public sigContainer1: QueryList<ElementRef>;

  constructor(fb: FormBuilder) {

    this.form = fb.group({
      signatureField1: ['', Validators.required],
    });
  }

  public ngAfterViewInit() {
    this.beResponsive();
    this.setOptions();
  }

  // set the dimensions of the signature pad canvas
  public beResponsive() {
    // console.log('Resizing signature pad canvas to suit container size')
    this.size(this.sigContainer1.first, this.sig);
  }

  public size(container: ElementRef, sig: SignatureFieldComponent){
    sig.signaturePad.set('canvasWidth', container.nativeElement.clientWidth);
    sig.signaturePad.set('canvasHeight', container.nativeElement.clientHeight);
  }

  public setOptions() {
    this.sig.signaturePad.set('penColor', 'rgb(0, 0, 0)');
    // this.sigs.last.signaturePad.set('penColor', 'rgb(255, 255, 0)');
    this.sig.signaturePad.set('backgroundColor', 'rgb(255,255,255)');
    // this.sigs.last.signaturePad.clear(); // clearing is needed to set the background colour
  }

  public done() {
    // console.log('CAPTURED SIGS:');
    // console.log(this.sig.signature);
    this.onDone.emit(this.sig.signature);
  }

  public clear() {
    this.sig.clear();
  }
  submit(){

  }
}
